import React from 'react';

import { DevicesViewColumns, DeviceType } from 'utils/constant';
import EditCollectionView from '../../common/EditCollectionView';
import DevicesView from '../DevicesView';

const ConstructionMachinesPage = () => {
    return (
        <EditCollectionView 
            content={DevicesView} 
            editPath="constructionmachine" 
            endpoint="devices" 
            type={DeviceType.CONSTRUCTION_MACHINE}
            columns={[
                DevicesViewColumns.LABEL,
                DevicesViewColumns.TRACKER_IDENTIFIER,
                DevicesViewColumns.BRAND,
                DevicesViewColumns.MODEL,
                DevicesViewColumns.GROUP,
            ]}
        />
    );
}

export default ConstructionMachinesPage;